<template>
  <el-card
    class="nav-card"
    shadow="never"
    :body-style="{ padding: 0, display: 'flex', 'flex-direction': 'column', height: '100%' }"
  >
    <div class="logo" @click="goHome">
      <img v-if="isCollapse" src="@/assets/nav_left_Collapse_menu_logo.png" alt="" />
      <img v-else src="@/assets/yf.svg" alt="" />
    </div>
    <div class="menu">
      <el-skeleton :loading="loading" animated>
        <template #template>
          <div style="padding: 14px" v-for="item in 10" :key="item">
            <el-skeleton-item variant="h3" style="width: 50%" />
            <el-skeleton-item variant="text" />
          </div>
        </template>
        <template #default>
          <el-menu
            :collapse="isCollapse"
            :collapse-transition="false"
            :default-active="defaultActive"
            @select="selectChange"
          >
            <template v-for="item in store.state.menu.menuList" :key="item.MenuId">
              <MenuItem :menuItem="item" />
            </template>
          </el-menu>
        </template>
      </el-skeleton>
    </div>
  </el-card>
</template>

<script>
import { defineComponent, ref, watch, computed } from 'vue'
import { useRoute, useRouter, onBeforeRouteUpdate } from 'vue-router'
import { useStore } from 'vuex'
import MenuItem from './MenuItem.vue'
import { getUserMenuList } from '@/services/user'
import { $t } from '@/lang'
import { ElMessage } from 'element-plus'
export default defineComponent({
  name: 'ContainerNavMenu',
  components: {
    MenuItem
  },
  props: {
    collapseStatus: Boolean
  },
  setup(props) {
    const isCollapse = ref(false)
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const loading = computed(() => store.state.menu.menuLoading)

    // const menuList = ref([])
    // const getMenuList = async () => {
    //   try {
    //     const { data } = await getUserMenuList()
    //     store.commit('menu/setMenuList', data.menuList)
    //     store.commit('menu/setPageList', data.pageList)
    //     menuList.value = data.menuList
    //   } catch (error) {
    //     console.log(error)
    //   }
    // }
    // getMenuList()

    const currentMenu = ref('')
    const defaultActive = ref('')

    const setDefaultMenu = path => {
      defaultActive.value = path
    }
    setDefaultMenu(route.path)

    onBeforeRouteUpdate((to, from) => {
      setDefaultMenu(to.path)
    })

    const goHome = () => {
      router.push('/')
      store.commit('menu/setCurrentTab', {
        name: $t('main_home_home_name'),
        routeUrl: '/'
      })
      // history.pushState(null, null, '/')
    }

    watch(
      () => props.collapseStatus,
      newStatus => {
        isCollapse.value = newStatus
      }
    )

    const selectChange = url => {
      // 控制塔大屏域名和token编码拼接到url后面
      if (url.indexOf('logistics-control') > -1) {
        const { token } = store.state.user.userInfo
        const envInfo = store.state.env.envInfo || {}
        if (!envInfo?.EnvironmentName || !envInfo?.RegionName) {
          return ElMessage.error('环境异常，请重新登陆！')
        }
        const baseUrl = `/lct/${envInfo?.EnvironmentName?.toLowerCase()}-${envInfo?.RegionName?.toLowerCase()}/gw/omd/lct-management/basicData/operatingList`
        const env = `${location.host}/login`
        const lctUrl = `${url}?token=${encodeURIComponent(token)}&baseUrl=${encodeURIComponent(
          baseUrl
        )}&env=${encodeURIComponent(env)}`
        window.open(lctUrl)
      } else {
        router.push(url)
      }
      // history.pushState(null, null, index)
    }

    return {
      isCollapse,
      // menuList,
      store,
      currentMenu,
      defaultActive,
      goHome,
      selectChange,
      loading
    }
  }
})
</script>

<style lang="scss" scoped>
.nav-card {
  height: 100%;
  border: none !important;
  border-radius: 0;

  .logo {
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .menu {
    margin-top: 10px;
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
    padding-bottom: 40px;
    box-sizing: border-box;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .el-menu {
      border: none;
      width: 100%;
      :deep(.el-sub-menu__title) {
        height: 50px;
        line-height: 50px;
      }

      :deep(.el-menu-item) {
        i {
          color: $title-color;
        }
      }
      & > .el-sub-menu > :deep(.el-sub-menu__title) {
        font-weight: bold;
      }
      & > .el-menu-item {
        font-weight: bold;
      }
    }
  }
}
</style>
